(function actionTypesDefinition() {
    'use strict';
    angular.module('Entities')
        .service('actionTypesService', [
            'restUrlBuilder', function actionTypesService(restUrlBuilder) {

                var urlCpp = restUrlBuilder('cpp');

                this.get = function get() {
                    return urlCpp.all('Audit/GetActionTypes')
                        .get()
                };
            }
        ]);

})();